import { useMemo } from 'react';

// components
import { AccountPopoverSection } from 'app/modules/navigator/components/AccountPopoverSection';
import { U21Divider, U21Switch } from 'app/shared/u21-ui/components';

// icons
import { IconDeviceImac } from '@u21/tabler-icons';

// models
import { PopoverSectionProps } from 'app/modules/navigator/models';
import { SessionAgent } from 'app/modules/session/models';
import { AgentCurrentStatus } from 'app/modules/agents/models';

// queries
import { useUpdateAgentCurrentStatus } from 'app/modules/agents/queries/useUpdateAgentCurrentStatus';

// selectors
import { selectRoundRobinAlertAssignmentEnabled } from 'app/shared/featureFlags/selectors';
import { useSelector } from 'react-redux';

interface OwnProps extends Omit<PopoverSectionProps, 'closePopover'> {
  agent: SessionAgent;
}

export const AgentAvailabilitySection = ({ agent }: OwnProps) => {
  const isRoundRobinAlertAssignmentEnabled = useSelector(
    selectRoundRobinAlertAssignmentEnabled,
  );

  const { id, current_status: currentStatus } = agent;

  const { mutate: updateAgentCurrentStatus } = useUpdateAgentCurrentStatus();

  const options = useMemo(
    () => [
      {
        key: 'availability',
        text: 'Available',
        icon: <IconDeviceImac />,
        tooltip: 'Toggle your availability for auto-assignment',
        rightIcon: (
          <U21Switch
            checked={
              !currentStatus || currentStatus === AgentCurrentStatus.AVAILABLE
            }
            onClick={(e) => {
              e.stopPropagation();
            }}
            onChange={(isAvailable) => {
              updateAgentCurrentStatus({
                id,
                payload: {
                  current_status: isAvailable
                    ? AgentCurrentStatus.AVAILABLE
                    : AgentCurrentStatus.UNAVAILABLE,
                },
              });
            }}
          />
        ),
      },
    ],
    [updateAgentCurrentStatus, currentStatus, id],
  );

  if (!isRoundRobinAlertAssignmentEnabled) {
    return null;
  }

  return (
    <>
      <U21Divider horizontal />
      <AccountPopoverSection
        title="Agent Availability"
        items={options}
        closePopover={() => {}}
      />
    </>
  );
};
